import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import cx from 'clsx';

export const TimeoutToast = ({ retry }) => {
	const { t } = useTranslation();

	const errorToast = ({ closeToast, data, toastProps }) => {
		const isColored = toastProps.theme === 'colored';

		return (
			<div className={`flex flex-col w-full`}>
				<div className="flex items-center justify-between">
					<p className="text-sm">{data.content}</p>
					<button
						style={{ borderRadius: '0.25rem' }}
						onClick={() => {
							closeToast();
							retry();
						}}
						className={cx('ml-auto transition-all text-xs  border rounded-md px-4 py-2 text-white active:scale-[.95]', isColored ? 'bg-transparent' : 'bg-zinc-900')}>
						{t('to.retryLabel')}
					</button>
				</div>
			</div>
		);
	};

	toast.error(errorToast, {
		position: 'top-right',
		autoClose: 9000,
		hideProgressBar: false,
		closeOnClick: false,
		pauseOnHover: true,
		draggable: true,
		data: {
			content: t('to.timeoutMessage'),
		},
		ariaLabel: t('to.timeoutMessage'),
		theme: 'colored',
		className: 'bg-danger',
	});
};
